import { InlineWidget } from "react-calendly";

type Props = Readonly<{
  url: string;
}>;

export function CalendlyInlineWidget({ url }: Props): JSX.Element {
  return (
    <>
      <InlineWidget url={url} />
    </>
  );
}
